import { Component, OnInit, ViewEncapsulation, ViewChild, ElementRef } from '@angular/core';
import { Hotkey, HotkeysService } from 'angular2-hotkeys';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { VbtDocumentType } from '@global-enum/GeneralUtility';
import { AppHelper, isDate } from '@shared-helpers/app-helper';
import { DocumentTypeAuthorizedModel } from '@global-models/Response/DocumentTypeAuthorizedModel';
import { MessageComponent } from '@global-message/Message.component';
import { cloneService } from '@global-services/CloneService';
import { GlobalSearchRequestModel } from 'app/vbt-ticari/GlobalSearch/_models/GlobalSearchRequestModel';
import { PartyFirmViewModel } from 'app/vbt-back-office/Customer/_models/PartyFirmViewModel';
import { CustomerService } from 'app/vbt-back-office/Customer/_services/Customer.service';
import { DateRangeResponseModel } from 'app/vbt-ticari/common/_models/DateRangeResponseModel';


@Component({
    selector: 'search-bar',
    templateUrl: './search-bar.template.html',
    styleUrls: ['./search-bar.css', './../../../vbt-ticari/common/_style/common-style.css'],
    encapsulation: ViewEncapsulation.None,
})

export class SearchBarComponent implements OnInit {

    public documentTypeAuthorizedModel: DocumentTypeAuthorizedModel = new DocumentTypeAuthorizedModel();

    public searchRequestModel: GlobalSearchRequestModel = new GlobalSearchRequestModel();
    public searchDetailPopup: boolean = false;

    public partyList: Array<PartyFirmViewModel> = new Array<PartyFirmViewModel>();
    public partyOutFocusSubscription: any;

    @ViewChild('messageVbt') msgVbt: MessageComponent;
    @ViewChild('DocumentDateRange') documentDateRange: ElementRef;

    constructor(
        private _cloneService: cloneService,
        private _hotkeysService: HotkeysService,
        private _router: Router,
        private _customerService: CustomerService
    ) { }

    ngOnInit(): void {
        this.DocumentAuhtSettings();
    }

    Search() {
        if (!this.SearchControl()) {
            return;
        }

        this.RedirectPage();
    }

    SearchControl(): boolean {
        let result = false;

        if (!AppHelper.IsNullOrEmpty(this.searchRequestModel.SearchKey)) {
            this.searchRequestModel.SearchKey = this.searchRequestModel.SearchKey.trim();
            if (this.searchRequestModel.SearchKey.length >= 3) {
                result = true;
            }
        }

        if (!result && !AppHelper.IsNullOrUndefined(this.searchRequestModel.IssueDate)) {
            if (isDate(this.searchRequestModel.IssueDate.StartDate) && isDate(this.searchRequestModel.IssueDate.EndDate)) {
                result = true;
            }
        }

        return result;
    }

    RedirectPage() {
        this.CloseGlobalSearchDetailPopup();

        const url = '/GlobalSearch/Search';
        const activeUrl = this._router.url;
        const id = AppHelper.NewGuid();
        this.searchRequestModel.UUId = id;
        this.searchRequestModel.MyCustomList = false;

        if (this.searchRequestModel.CustomerFirmId > 0 && this.searchRequestModel.CustomerId > 0) {
            this.searchRequestModel.SearchKey = null;
        }
        sessionStorage.removeItem('SearchModel');
        sessionStorage.setItem('SearchModel', JSON.stringify(this.searchRequestModel));

        this.searchRequestModel.SearchKey = null;
        this.searchRequestModel.CustomerFirmId = 0;
        this.searchRequestModel.CustomerId = 0;

        this.partyList = new Array<PartyFirmViewModel>();

        if (url === activeUrl) {
            this._router.navigate([`/GlobalSearch/Search/${id}`]);
        }
        else {
            this._router.navigate([`/GlobalSearch/Search`]);
        }
    }

    Clear() {
        this.searchRequestModel = new GlobalSearchRequestModel();
        this.documentDateRange.nativeElement.value = null;
    }

    DatePickerChange(event: any, dateNow: boolean = false) {
        this.searchRequestModel.IssueDate = new DateRangeResponseModel();
        if (!AppHelper.IsNullOrUndefined(event)) {
            this.searchRequestModel.IssueDate.StartDate = new Date(AppHelper.getDateFormat(new Date(event[0])) + 'T00:00:00.001Z');
            this.searchRequestModel.IssueDate.EndDate = new Date(AppHelper.getDateFormat(new Date(event[1])) + 'T23:59:59.000Z');
        }
        else if (dateNow) {
            this.searchRequestModel.IssueDate.StartDate = new Date(AppHelper.getDateFormat(new Date()) + 'T00:00:00.001Z');
            this.searchRequestModel.IssueDate.EndDate = new Date(AppHelper.getDateFormat(new Date()) + 'T23:59:59.000Z');

            let startDate = this._cloneService.cloneModel(this.searchRequestModel.IssueDate.StartDate);
            let endDate = this._cloneService.cloneModel(this.searchRequestModel.IssueDate.EndDate);

            const dd1 = '0' + startDate.getDate();
            const mm1 = '0' + (startDate.getMonth() + 1);
            const yyyy1 = startDate.getFullYear();
            const start = dd1.substring(dd1.length, dd1.length - 2) + '.' + mm1.substring(mm1.length, mm1.length - 2) + '.' + yyyy1;

            endDate.setHours(-3);
            const dd2 = '0' + endDate.getDate();
            const mm2 = '0' + (endDate.getMonth() + 1);
            const yyyy2 = endDate.getFullYear();
            const end = dd2.substring(dd2.length, dd2.length - 2) + '.' + mm2.substring(mm2.length, mm2.length - 2) + '.' + yyyy2;

            this.documentDateRange.nativeElement.value = start + ' - ' + end;
        }
        else {
            this.documentDateRange.nativeElement.value = null;
        }
    }

    OpenGlobalSearchDetailPopup() {
        if (!this.searchDetailPopup) {
            this._hotkeysService.add(new Hotkey('esc', (): boolean => { this.CloseGlobalSearchDetailPopup(); return true; }));
            $('.search-block-popup').fadeIn();
            this.searchDetailPopup = true;
        }
        else {
            this.CloseGlobalSearchDetailPopup();
        }

    }

    CloseGlobalSearchDetailPopup() {
        $('.search-block-popup').fadeOut();
        this._hotkeysService.remove(new Hotkey('esc', (): boolean => { return true; }));
        this.searchDetailPopup = false;
    }

    DocumentAuhtSettings() {
        const documentAuthList = AppHelper.DocumentAuthList();

        this.documentTypeAuthorizedModel.OutgoingInvoice = documentAuthList.includes(VbtDocumentType.OutgoingInvoice);
        this.documentTypeAuthorizedModel.IncomingInvoice = documentAuthList.includes(VbtDocumentType.IncomingInvoice);
        this.documentTypeAuthorizedModel.EarchiveInvoice = documentAuthList.includes(VbtDocumentType.EArchiveInvoice);
        this.documentTypeAuthorizedModel.MyCustomIncomingInvoice = documentAuthList.includes(VbtDocumentType.MyCustomIncomingInvoice);
        this.documentTypeAuthorizedModel.OutgoingDespatchAdvice = documentAuthList.includes(VbtDocumentType.OutgoingDespatchAdvice);
        this.documentTypeAuthorizedModel.IncomingDespatchAdvice = documentAuthList.includes(VbtDocumentType.IncomingDespatchAdvice);
        this.documentTypeAuthorizedModel.MyCustomIncomingDespatchAdvice = documentAuthList.includes(VbtDocumentType.MyCustomIncomingDespatchAdvice);
        this.documentTypeAuthorizedModel.CreditNote = documentAuthList.includes(VbtDocumentType.OutgoingCreditNote);
        this.documentTypeAuthorizedModel.ESMM = documentAuthList.includes(VbtDocumentType.OutgoingSMM);
        this.documentTypeAuthorizedModel.MigratedOutgoingInvoice = documentAuthList.includes(VbtDocumentType.MigratedOutgoingInvoice);
        this.documentTypeAuthorizedModel.MigratedIncomingInvoice = documentAuthList.includes(VbtDocumentType.MigratedIncomingInvoice);

        this.searchRequestModel.SearchOutgoingInvoice = this.documentTypeAuthorizedModel.OutgoingInvoice;
        this.searchRequestModel.SearchIncomingInvoice = this.documentTypeAuthorizedModel.IncomingInvoice;
        this.searchRequestModel.SearchEArchiveInvoice = this.documentTypeAuthorizedModel.EarchiveInvoice;
        this.searchRequestModel.SearchMyCustomIncomingInvoice = this.documentTypeAuthorizedModel.MyCustomIncomingInvoice;
        this.searchRequestModel.SearchOutgoingDespatchAdvice = this.documentTypeAuthorizedModel.OutgoingDespatchAdvice;
        this.searchRequestModel.SearchIncomingDespatchAdvice = this.documentTypeAuthorizedModel.IncomingDespatchAdvice;
        this.searchRequestModel.SearchMyCustomIncomingDespatchAdvice = this.documentTypeAuthorizedModel.MyCustomIncomingDespatchAdvice;
        this.searchRequestModel.SearchCreditNote = this.documentTypeAuthorizedModel.CreditNote;
        this.searchRequestModel.SearchSMM = this.documentTypeAuthorizedModel.ESMM;
        this.searchRequestModel.SearchMigratedOutgoingInvoice = this.documentTypeAuthorizedModel.MigratedOutgoingInvoice;
        this.searchRequestModel.SearchMigratedIncomingInvoice = this.documentTypeAuthorizedModel.MigratedIncomingInvoice;

    }

    SelectAllDocument(select: boolean) {
        this.searchRequestModel.SearchOutgoingInvoice = select;
        this.searchRequestModel.SearchIncomingInvoice = select;
        this.searchRequestModel.SearchMyCustomIncomingInvoice = select;
        this.searchRequestModel.SearchEArchiveInvoice = select;
        this.searchRequestModel.SearchOutgoingDespatchAdvice = select;
        this.searchRequestModel.SearchIncomingDespatchAdvice = select;
        this.searchRequestModel.SearchMyCustomIncomingDespatchAdvice = select;
        this.searchRequestModel.SearchCreditNote = select;
        this.searchRequestModel.SearchSMM = select;
        this.searchRequestModel.SearchMigratedOutgoingInvoice = select;
        this.searchRequestModel.SearchMigratedIncomingInvoice = select;
    }

    //#region Party

    GetPartyFirmList() {

        this._customerService.GetPartyFirmList(this.searchRequestModel.SearchKey.trim())
            .then(result => {
                const model = ((result || new Array<PartyFirmViewModel>()) as Array<PartyFirmViewModel>);
                if (model.length > 0) {
                    model.map(x => x.Label = x.PartyName + ' | ' + x.FirmName);
                    this.partyList = model;
                    this.PartySelectArrowKey(0, true);
                }
            }).catch((ex: HttpErrorResponse) => {
                AppHelper.ThrowException(ex, this.msgVbt);
            });
    }

    PartyOutFocus() {

        setTimeout(() => {
            this.partyList = new Array<PartyFirmViewModel>();
            this.partyOutFocusSubscription?.unsubscribe();
        },500);
    }

    PartySelectedInList(model: PartyFirmViewModel) {
        if (model.IdentityOrTaxNumber === '1111111111' || model.IdentityOrTaxNumber === '11111111111') {
            this.searchRequestModel.SearchKey = model.PartyName;
            this.RedirectPage();
        }
        else {
            this.searchRequestModel.CustomerId = model.PartyId;
            this.searchRequestModel.CustomerFirmId = model.FirmId;
            this.RedirectPage();
        }
    }

    PartyFirmSearch(event: any) {
        if (AppHelper.IsNullOrEmpty(this.searchRequestModel.SearchKey)) {
            this.partyList = new Array<PartyFirmViewModel>();
            this.searchRequestModel.SearchKey = '';
        }

        if (AppHelper.IsNullOrEmpty(this.searchRequestModel.SearchKey.trim())) {
            this.partyList = new Array<PartyFirmViewModel>();
            return;
        }

        if (this.searchRequestModel.SearchKey.trim().length < 3) {
            this.partyList = new Array<PartyFirmViewModel>();
            return;
        }

        /* event.keyCode === 40 : Aşağı Ok */
        /* event.keyCode === 38 : Yukarı Ok */

        if (event.keyCode === 40 || event.keyCode === 38) {
            return;
        }

        this.GetPartyFirmList();
    }

    PartySelected(event: any) {
        if (event.keyCode === 13) {
            const selectedParty = this.partyList.find(x => x.PartySelected === true);
            if (!AppHelper.IsNullOrUndefined(selectedParty)) {
                this.PartySelectedInList(selectedParty);
            }
            else {
                this.Search();
                this.partyList = new Array<PartyFirmViewModel>();
            }
        }

        if (this.partyList.length > 0 && (event.keyCode === 40 || event.keyCode === 38)) {
            const selectedParty = this.partyList.find(x => x.PartySelected === true);

            if (event.keyCode === 40) {
                $('.search_party_item:not(:last-child).search_party_item_hover').removeClass('search_party_item_hover').next().addClass('search_party_item_hover');
                if (AppHelper.IsNullOrUndefined(selectedParty)) {
                    this.PartySelectArrowKey(0, true);
                }
                else {
                    const index = this.partyList.findIndex(x => x.PartySelected === true)
                    this.PartySelectArrowKey(index, false);

                    if (index === (this.partyList.length - 1)) {
                        this.PartySelectArrowKey((this.partyList.length - 1), true);
                    }
                    else if ((index + 1) < this.partyList.length) {
                        this.PartySelectArrowKey((index + 1), true);
                    }
                }
            }
            else if (event.keyCode === 38) {
                $('.search_party_item:not(:first-child).search_party_item_hover').removeClass('search_party_item_hover').prev().addClass('search_party_item_hover');
                if (AppHelper.IsNullOrUndefined(selectedParty)) {
                    this.PartySelectArrowKey((this.partyList.length - 1), true);
                }
                else {
                    const index = this.partyList.findIndex(x => x.PartySelected === true)
                    this.PartySelectArrowKey(index, false);

                    if (index === 0) {
                        this.PartySelectArrowKey(index, true);
                    }
                    else if ((index - 1) >= 0) {
                        this.PartySelectArrowKey((index - 1), true);
                    }
                }
            }

            $('.search_party_list .search_party_list_outer_div').scrollTop(0);//set to top
            $('.search_party_list .search_party_list_outer_div').scrollTop($('.search_party_item_hover:first').offset().top - $('.search_party_list .search_party_list_outer_div').height());
        }

    }

    PartySelectArrowKey(index: number, select: boolean) {
        this.partyList[index].PartySelected = select;
    }

}
